import { Inject, OnInit } from '@angular/core';
import { CarFinanceObject, LandFinanceObject } from '../../../models/finance-document.model';
import { map, tap} from 'rxjs/operators';
import { BaseDictionary, ServerDTO } from '../../../models/app.model';
import { dtoFormatter } from '../../../shared/helpers/helper.system';
import { RestService } from '../../../service/rest.service';
import { Observable, pipe } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import swal from 'sweetalert2';
import { AppAlerts } from '../../../shared/configs/app.alerts';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../store/reducers';
import * as messageActions from '../../../store/actions/messages';
import { AppMessages } from '../../../shared/configs/app.messages';

/**
 * For adding cars and lands
 */
export abstract class BaseAbstractFinanceObjectAdderComponent implements OnInit {

  idFinance: string;
  //
  type: string; // 'car' | 'land'
  object: any;
  objectId: string;
  //
  isAdd: boolean;
  // types
  typeObjects: Array<BaseDictionary> = [];
  // names
  nameObjects: Array<BaseDictionary> = [];
  // address
  addressObjects: Array<BaseDictionary> = [];
  //
  protected data$: Observable<any>;
  protected types$: Observable<any>;
  protected names$: Observable<any>;
  protected addresses$: Observable<any>;


  constructor(public dialogRef: MatDialogRef<any>,
              protected restService: RestService,
              protected store: Store<fromRoot.AppState>,
              @Inject(MAT_DIALOG_DATA) public data: {object: CarFinanceObject | LandFinanceObject, id: string}) {
    this.object = data && data.object ? data.object : <CarFinanceObject | LandFinanceObject>{};
    this.objectId = this.object ? this.object.id : null;
    this.idFinance = this.data && this.data.id ? this.data.id : null;
    this.isAdd = Object.keys(this.object).length > 0 ? false : true;
  }

  ngOnInit() {
    this.data$.subscribe(() => {
      // edit mode <-- it's a bit redundant but it's needed for working rxjs
      this.isAdd = this.isEmptyObject();
    });
  }

  abstract saveData$(): Observable<any>;

  isEmptyObject() {
    return !Object.keys(this.object).length ? true : false;
  }

  /**
   * Common pipes
   */
  protected pipeType = () => pipe(
      map( (p: ServerDTO) => dtoFormatter<BaseDictionary>(p)),
      tap((data: any) => this.typeObjects = data)
  )

  protected pipeName = () => pipe(
    map( (p: ServerDTO) => dtoFormatter<BaseDictionary>(p)),
    tap((data: any) => this.nameObjects = data)
  )

  protected pipeAddress = () => pipe(
    map( (p: ServerDTO) => dtoFormatter<BaseDictionary>(p)),
    tap((data: any) => this.addressObjects = data)
  )


  save() {

    const _this = this; // reference

    swal({
      title: AppAlerts.SAVE_OBJECT_TITLE,
      type: 'warning',
      showCancelButton: true,
    }).then(function (action) {

      if (action.value === true) {

        // check object (1)
        if ( _this.isEmptyObject() ) {
          swal({
            title: AppAlerts.OBJECT_IS_EMPTY,
            type: 'error',
          });
          return;
        }

        if (!_this.object.name || !_this.object.type ||
          (_this.type === 'land' && (!_this.object.landS || !_this.object.address))
        ) {
          swal({
            title: AppAlerts.ERROR_REQUIRED_FIELDS,
            type: 'error',
          });
          return;
        }

        if ( _this.type === 'land' && isNaN(_this.object.landS) ) {
          swal({
            title: AppAlerts.FINANCE_LANDS_ERROR,
            type: 'error',
          });
          return;
        }

        _this.saveData$()
            .subscribe(
              (d: any) => {
                _this.store.dispatch(new messageActions.SuccessMessage(AppMessages.APP_SAVE_SUCCESS));
                if (_this.isAdd) {
                  _this.object.id = d.insertId;
                }
                _this.dialogRef.close(_this.object);
              },
              error => {
                _this.store.dispatch(new messageActions.ErrorMessage(AppMessages.APP_SAVE_ERROR));
              }
        );
      }

    });
  }

}
